<template>
  <div class="qr-code" v-html="svgOutput" :style="{ 'height': size, 'width': size }"></div>
</template>

<script setup lang="ts">
// @ts-ignore
import bwipjs from 'bwip-js';
import { onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const i18n = useI18n();

const unavailableSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="rgb(255 193 7)" stroke="rgb(255 193 7)"><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>`;

const svgOutput = ref<string>(unavailableSvg);

const props = defineProps({
  text: { type: String, required: true },
  size: { type: String, default: '1rem' },
});

onMounted(() => {
  svgOutput.value = toQrCodeSvg(props.text);
});

watch(() => props.text, (newText) => {
  svgOutput.value = toQrCodeSvg(newText);
});

const generateQrCode = (text: string): string => {
  return (bwipjs as any).toSVG({
    bcid: 'qrcode',
    text: text,
    backgroundcolor: 'FFFFFF',
    scale: 1,
    paddingwidth: 4,
    paddingheight: 4,
  });
};

const toQrCodeSvg = (text: string): string => {
  if (!text || text.length === 0) {
    const msg = i18n.t('error.noCode');
    console.info(msg);
    return `<span title="${msg}">` + unavailableSvg + "</span>";
  }
  try {
    return generateQrCode(text);
  } catch (error) {
    if (error instanceof Error) {
      console.info(error.message);
      return `<span title="${error.message}">` + unavailableSvg + "</span>";
    }
    else {
      console.info(error);
      return `<span title="${error}">` + unavailableSvg + "</span>";
    }
  }
};
</script>

<style scoped>
.qr-code {
  box-shadow: 0 0 0.5rem 0.25rem white;
}
</style>
